export const ds_EventsLayoutBlock_Entry = `
    fragment ds_EventsLayoutBlock_Entry on ds_EventsLayoutBlock_Entry {
        id
        canonicalUid
        events_SelectArticle {
            id
            canonicalUid
        }
        events_Orientation
        events_CardStyle
        events_ImageAspectRatio
        events_ShowTopLabel
        events_TopLabelStyle
        events_ButtonText
        events_ColorTheme
        events_ColorPalette
    }
`